"use client";

import React from "react";
import EnqueryForm from "@/components/forms/EnqueryForm";
import { FormHeading, SuccessMessageType } from "@/interface/types";

const IMAGE_BASE = "https://ik.imagekit.io/mileseducation/miles_website/home_2026";

const srcSet = (file: string, widths: number[]) =>
  widths
    .map((w) => `${IMAGE_BASE}/${file}?tr=w-${w},q-85,f-webp ${w}w`)
    .join(", ");

const BORDER_MASK: React.CSSProperties = {
  WebkitMask:
    "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
  WebkitMaskComposite: "xor",
  mask: "linear-gradient(#000 0 0) content-box exclude, linear-gradient(#000 0 0)",
};

const CalendarIcon = () => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className="size-6 shrink-0"
  >
    <path
      d="M19.5 3H17.25V2.25C17.25 2.05109 17.171 1.86032 17.0303 1.71967C16.8897 1.57902 16.6989 1.5 16.5 1.5C16.3011 1.5 16.1103 1.57902 15.9697 1.71967C15.829 1.86032 15.75 2.05109 15.75 2.25V3H8.25V2.25C8.25 2.05109 8.17098 1.86032 8.03033 1.71967C7.88968 1.57902 7.69891 1.5 7.5 1.5C7.30109 1.5 7.11032 1.57902 6.96967 1.71967C6.82902 1.86032 6.75 2.05109 6.75 2.25V3H4.5C4.10218 3 3.72064 3.15804 3.43934 3.43934C3.15804 3.72064 3 4.10218 3 4.5V19.5C3 19.8978 3.15804 20.2794 3.43934 20.5607C3.72064 20.842 4.10218 21 4.5 21H19.5C19.8978 21 20.2794 20.842 20.5607 20.5607C20.842 20.2794 21 19.8978 21 19.5V4.5C21 4.10218 20.842 3.72064 20.5607 3.43934C20.2794 3.15804 19.8978 3 19.5 3ZM6.75 4.5V5.25C6.75 5.44891 6.82902 5.63968 6.96967 5.78033C7.11032 5.92098 7.30109 6 7.5 6C7.69891 6 7.88968 5.92098 8.03033 5.78033C8.17098 5.63968 8.25 5.44891 8.25 5.25V4.5H15.75V5.25C15.75 5.44891 15.829 5.63968 15.9697 5.78033C16.1103 5.92098 16.3011 6 16.5 6C16.6989 6 16.8897 5.92098 17.0303 5.78033C17.171 5.63968 17.25 5.44891 17.25 5.25V4.5H19.5V7.5H4.5V4.5H6.75ZM19.5 19.5H4.5V9H19.5V19.5ZM13.125 12.375C13.125 12.5975 13.059 12.815 12.9354 13C12.8118 13.185 12.6361 13.3292 12.4305 13.4144C12.225 13.4995 11.9988 13.5218 11.7805 13.4784C11.5623 13.435 11.3618 13.3278 11.2045 13.1705C11.0472 13.0132 10.94 12.8127 10.8966 12.5945C10.8532 12.3762 10.8755 12.15 10.9606 11.9445C11.0458 11.7389 11.19 11.5632 11.375 11.4396C11.56 11.316 11.7775 11.25 12 11.25C12.2984 11.25 12.5845 11.3685 12.7955 11.5795C13.0065 11.7905 13.125 12.0766 13.125 12.375ZM17.25 12.375C17.25 12.5975 17.184 12.815 17.0604 13C16.9368 13.185 16.7611 13.3292 16.5555 13.4144C16.35 13.4995 16.1238 13.5218 15.9055 13.4784C15.6873 13.435 15.4868 13.3278 15.3295 13.1705C15.1722 13.0132 15.065 12.8127 15.0216 12.5945C14.9782 12.3762 15.0005 12.15 15.0856 11.9445C15.1708 11.7389 15.315 11.5632 15.5 11.4396C15.685 11.316 15.9025 11.25 16.125 11.25C16.4234 11.25 16.7095 11.3685 16.9205 11.5795C17.1315 11.7905 17.25 12.0766 17.25 12.375ZM9 16.125C9 16.3475 8.93402 16.565 8.8104 16.75C8.68679 16.935 8.51109 17.0792 8.30552 17.1644C8.09995 17.2495 7.87375 17.2718 7.65552 17.2284C7.43729 17.185 7.23684 17.0778 7.0795 16.9205C6.92217 16.7632 6.81502 16.5627 6.77162 16.3445C6.72821 16.1262 6.75049 15.9 6.83564 15.6945C6.92078 15.4889 7.06498 15.3132 7.24998 15.1896C7.43499 15.066 7.6525 15 7.875 15C8.17337 15 8.45952 15.1185 8.6705 15.3295C8.88147 15.5405 9 15.8266 9 16.125ZM13.125 16.125C13.125 16.3475 13.059 16.565 12.9354 16.75C12.8118 16.935 12.6361 17.0792 12.4305 17.1644C12.225 17.2495 11.9988 17.2718 11.7805 17.2284C11.5623 17.185 11.3618 17.0778 11.2045 16.9205C11.0472 16.7632 10.94 16.5627 10.8966 16.3445C10.8532 16.1262 10.8755 15.9 10.9606 15.6945C11.0458 15.4889 11.19 15.3132 11.375 15.1896C11.56 15.066 11.7775 15 12 15C12.2984 15 12.5845 15.1185 12.7955 15.3295C13.0065 15.5405 13.125 15.8266 13.125 16.125ZM17.25 16.125C17.25 16.3475 17.184 16.565 17.0604 16.75C16.9368 16.935 16.7611 17.0792 16.5555 17.1644C16.35 17.2495 16.1238 17.2718 15.9055 17.2284C15.6873 17.185 15.4868 17.0778 15.3295 16.9205C15.1722 16.7632 15.065 16.5627 15.0216 16.3445C14.9782 16.1262 15.0005 15.9 15.0856 15.6945C15.1708 15.4889 15.315 15.3132 15.5 15.1896C15.685 15.066 15.9025 15 16.125 15C16.4234 15 16.7095 15.1185 16.9205 15.3295C17.1315 15.5405 17.25 15.8266 17.25 16.125Z"
      fill="#FFBA08"
    />
  </svg>
);

const WebinarBannerNew = () => {
  return (
    <section
      aria-labelledby="cma-webinar-heading"
      className="relative overflow-hidden bg-gradient-to-b from-black to-[#1E1E1E]"
    >
      <picture>
        <source
          media="(min-width: 768px)"
          srcSet={srcSet("webinar_desktop.png", [367, 734])}
          sizes="367px"
        />
        <img
          src={`${IMAGE_BASE}/webinar_mob.png?tr=w-702,q-85,f-webp`}
          srcSet={srcSet("webinar_mob.png", [316, 632])}
          sizes="316px"
          alt="Varun Jain, CMA instructor and founder of Miles Education"
          width={702}
          height={710}
          loading="lazy"
          decoding="async"
          className="pointer-events-none absolute right-[-116px] top-[136px] h-auto w-[316px] select-none md:bottom-0 md:left-1/2 md:right-auto md:top-auto md:h-full md:w-auto md:-translate-x-1/2"
        />
      </picture>

      <div className="main_container relative grid grid-cols-1 md:min-h-[381px] md:grid-cols-[minmax(0,1fr)_400px] md:items-center md:gap-5">
        <div className="flex flex-col items-start pt-6 md:pb-12 md:pt-[52px]">
          <p className="flex h-[33px] items-center gap-1.5 rounded-[14px] border-[1.5px] border-white px-[11px] text-[14px] md:text-[16px] font-bold uppercase leading-none text-white md:h-9 md:rounded-[14px] md:px-[9px]">
            <span
              aria-hidden="true"
              className="size-2.5 rounded-full bg-[#FF000A]"
            />
            <span className="text-[#FF000A]">Live</span> Webinar
          </p>

          <h2
            id="cma-webinar-heading"
            className="mt-2.5 text-[32px] font-bold leading-[34px] text-white md:mt-2 md:text-[47px] md:leading-[55px]"
          >
            CMA Roadmap
            <br />
            with <span className="text-[#FFBA08]">Varun Jain</span>
          </h2>

          <p className="mt-3 max-w-[184px] text-base font-normal leading-[19px] tracking-normal text-white md:mt-2 md:max-w-[400px] md:text-[20px] md:leading-[25px]">
            Which credential, how long, what it costs, and where it takes you.
            Ask Varun anything about CMA, live in this webinar
          </p>

          <p className="mt-3.5 flex items-center gap-2.5 text-lg md:text-[20px] font-bold leading-6 tracking-normal text-white md:mt-4 md:gap-2.5">
            <CalendarIcon />
            <time className="tracking-[inherit]">Sunday, 4 PM IST</time>
          </p>
        </div>

        <div
          className="relative mb-[25px] mt-[58px] md:my-0 md:justify-self-end md:w-[400px]"
          id="webinar-form"
        >
          <div className="relative w-full rounded-2xl border border-[#333] bg-[#0B0B0B]/85 px-[18px] py-5 backdrop-blur-[2px]">
            {/* Two blue glows orbit the border; masked to the 1px ring so the card stays translucent. At rest (reduced motion) they sit top and bottom centre, as in the design. */}
            <span
              aria-hidden="true"
              style={BORDER_MASK}
              className="pointer-events-none absolute -inset-px overflow-hidden rounded-2xl p-px"
            >
              <span className="absolute left-1/2 top-1/2 -ml-[500px] -mt-[500px] size-[1000px] animate-[spin_6s_linear_infinite] bg-[conic-gradient(#3399FF_0deg,transparent_30deg_150deg,#3399FF_180deg,transparent_210deg_330deg,#3399FF_360deg)] motion-reduce:animate-none" />
            </span>
            <EnqueryForm
              courseId={2}
              course="CMA"
              darkBackground={true}
              submitButtonName="Register for Webinar"
              formType="webinar banner"
              isAStepperForm
              hideFormHeading
              successMessage={SuccessMessageType.ACCOUNTING}
              formHeading={FormHeading.AI_INTEGRATED_WEBINAR_CMA}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WebinarBannerNew;
